import ApiServices from "@/api/apexchat.api.services";
import { AnalyticAPI, general } from "@/api/endpoints";
import { createSlice } from "@reduxjs/toolkit";

export const getActivationStats = (payload) => {
  let analyticAPI = AnalyticAPI.getActivationStats;
  return ApiServices.post(analyticAPI, payload);
};

export const getLeadgeneratorStats = (payload) => {
  let analyticAPI = `${AnalyticAPI.getLeadgeneratorStats}?pageSize=${payload.pageSize}`;
  return ApiServices.post(analyticAPI, {});
};

export const getTopBottomBillersStats = (payload) => {
  let analyticAPI = `${AnalyticAPI.getTopBottomBillersStats}?pageSize=${payload.pageSize}`;
  return ApiServices.post(analyticAPI, {});
};

// export const getQuickStats = payload => {
//   let analyticAPI = AnalyticAPI.getQuickStats;
//   return ApiServices.getWithParams(analyticAPI, { params: payload });
// };

export const getQuickStats = (payload) => {
  let analyticAPI = AnalyticAPI.getQuickStats;
  return ApiServices.post(analyticAPI, payload);
};
export const getFilters = (payload) => {
  let analyticAPI = AnalyticAPI.getFilters;
  return ApiServices.getWithParams(analyticAPI, { params: payload });
};
export const getChartsAndGraphs = (payload) => {
  let analyticAPI = AnalyticAPI.getChartsAndGraphs;
  return ApiServices.post(analyticAPI, payload);
};

export const getChatReferralsStats = (payload) => {
  // TODO: replace the api with actual one
  // let analyticAPI = AnalyticAPI.getActivationStats;
  // return ApiServices.post(analyticAPI, payload);
  return true;
};

export const getFeaturesUsageStats = (payload) => {
  // TODO: replace the api with actual one
  // let analyticAPI = AnalyticAPI.getActivationStats;
  // return ApiServices.post(analyticAPI, payload);
  return true;
};

export const getTopReveneueStats = (payload) => {
  let analyticAPI = `${AnalyticAPI.getTopRevenueStats}?pageSize=${payload.pageSize}`;
  return ApiServices.post(analyticAPI, {});
};

export const getTopInactiveBillersStats = (payload) => {
  let analyticAPI = `${AnalyticAPI.getTopInactiveBillerStats}?pageSize=${payload.pageSize}`;
  return ApiServices.post(analyticAPI, {});
};

export const getBudgetPacingStats = (payload) => {
  let analyticAPI = `${AnalyticAPI.getBudgetPacingStats}?pageSize=${payload.pageSize}`;
  return ApiServices.post(analyticAPI, {});
};

export const getAgentImagesCTRStats = (payload) => {
  let analyticAPI = `${AnalyticAPI.getAgentImagesCTRStats}?pageSize=${payload.pageSize}`;
  return ApiServices.post(analyticAPI, {});
};

export const getAccountsStats = (payload) => {
  let analyticAPI = `${AnalyticAPI.getAccountsStats}?pageSize=${payload.pageSize}`;
  return ApiServices.post(analyticAPI, {});
};

export const getBusinessTypes = (payload) => {
  let analyticAPI = general.getBusinessCategories;
  return ApiServices.getWithParams(analyticAPI, {});
};

export const getBusinessSubCategories = (payload) => {
  let analyticAPI = general.getBusinessSubCategories;
  return ApiServices.getWithParams(analyticAPI, { params: payload });
};
// Redux Slice

const initialState = {
  clearAll: false,
  allowedFilters: {},
  appointmentStats: {
    "Last 24hrs": [
      { label: "Appointments Booked", value: 34, trend: "10%", isPositive: true },
      { label: "Appointments Rescheduled", value: 5, trend: "20%", isPositive: false },
      { label: "Appointments Canceled", value: 32, trend: "50%", isPositive: true },
    ],
    "Last Week": [
      { label: "Appointments Booked", value: 226, trend: "50%", isPositive: false },
      { label: "Appointments Rescheduled", value: 26, trend: "50%", isPositive: true },
      { label: "Appointments Canceled", value: 94, trend: "12%", isPositive: false },
    ],
    "Last Month": [
      { label: "Appointments Booked", value: 890, trend: "15%", isPositive: true },
      { label: "Appointments Rescheduled", value: 112, trend: "8%", isPositive: true },
      { label: "Appointments Canceled", value: 380, trend: "4%", isPositive: false },
    ]
  },
  bookedAppointments: {
    day: {
      labels: ["9 AM", "10 AM", "11 AM", "12 PM", "1 PM", "2 PM", "3 PM", "4 PM"],
      values: [2, 5, 3, 8, 4, 11, 6, 2],
    },
    week: {
      labels: ["Mon", "Tue", "Wed", "Thr", "Fri", "Sat", "Sun"],
      values: [62, 88, 56, 62, 62, 92, 74],
    },
    month: {
      labels: ["Week 1", "Week 2", "Week 3", "Week 4"],
      values: [45, 80, 65, 120],
    },
    "3_months": {
      labels: ["Jan", "Feb", "Mar"],
      values: [150, 210, 180],
    },
  },
  teamAppointments: {
    day: {
      labels: ["Alex", "Sam", "Jordan", "Casey", "Taylor"],
      values: [3, 5, 2, 4, 1],
    },
    week: {
      labels: ["Alex", "Sam", "Jordan", "Casey", "Taylor"],
      values: [15, 22, 18, 25, 10],
    },
    month: {
      labels: ["Alex", "Sam", "Jordan", "Casey", "Taylor"],
      values: [60, 85, 70, 95, 40],
    },
    "3_months": {
      labels: ["Alex", "Sam", "Jordan", "Casey", "Taylor"],
      values: [180, 250, 200, 280, 120],
    },
  },
};

export const flitersSlice = createSlice({
  name: "filters",
  initialState: { ...initialState },

  reducers: {
    /**
     * @name @login
     * @description login reducer to call login async API with axios instance
     * @requires ApiServices.get method, state and API payload
     **/

    // startLoading: (state = initialState, action) => {
    //   //  add random number to loading
    //   let randomeNumber = Math.floor(Math.random() * (80 - 20) + 20);
    //   if (state.loading + randomeNumber < 90)
    //     state.loading = state.loading + randomeNumber;
    //   else state.loading = randomeNumber;
    // },

    clearAll: (state, action) => {
      state.clearAll = action.payload;
    },
    setAllowedFilters: (state, action) => {
      state.allowedFilters = action.payload;
    },

    // showLoading: (state = initialState, action) => {
    //   state.show = action.payload;
    //   if (!action.payload) {
    //     state.loading = initialState.loading;
    //   }
    // }
  },
});

export const { clearAll, setAllowedFilters } = flitersSlice.actions;

/* called a selector and allows to select values from the state */
export const isClearAll = (state) => {
  return state.filters.clearAll;
};
export const getAllowedFilters = (state) => {
  return state.filters.allowedFilters;
};

// Selectors for Appointments Analytics Dummy Data
export const getAppointmentStats = (state) => state.filters.appointmentStats;
export const getBookedAppointments = (state) => state.filters.bookedAppointments;
export const getTeamAppointments = (state) => state.filters.teamAppointments;

export default flitersSlice.reducer;
